export enum ShowWeightType {
    Hide = 0,
    Show = 1
}
